// Shop browse, a product detail, and checkout. Segments, not a substring,
// so a future /shop-settings or /workshop path is not treated as the shop.
export function isShopRoute(path) {
  const parts = String(path || '').split('?')[0].split('#')[0].split('/').filter(Boolean);
  if (parts.indexOf('shop') !== -1 || parts.indexOf('checkout') !== -1) return true;
  const productIndex = parts.indexOf('product');
  return productIndex !== -1 && productIndex < parts.length - 1;
}

export function shopContentScroller() {
  return document.querySelector('.layout--main.is-shop-page #content-area > .content-wrapper');
}
